import React, { useMemo, useCallback } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	onChange: (value: string) => void;
	setId: string;
}

export const RecipientAccountNumberField: React.FC<IProps> = React.memo(({ onChange, setId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterRecipientAccountNumber') },
			{
				validator(_, value) {
					if (!value || value.length === 20 || value.length === 25) {
						return Promise.resolve();
					}
					return Promise.reject(new Error(t('recipientAccountNumberShouldContainCertainNumberOfDigits')));
				},
			},
		],
		[t],
	);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 25);
			onChange(onlyDigits);
			return onlyDigits;
		},
		[onChange],
	);

	return (
		<FormInputNew
			testId="RecipientAccountNumber"
			name={`recipientAccountNumber-${setId}`}
			label="recipientAccountNumberLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
});
